import { ColumnProps } from 'antd/lib/table'

import {
  ReimbursementHistoryFilter,
  ReimbursementHistoryItem,
} from 'core/application/adminDashboard/reimbursements/reimbursementsHistory/getReimbursementsHistory'
import { ExpenseStatus } from 'core/application/adminDashboard/reimbursements/transactions/transactions'
import { ProductIds } from 'core/application/commons/config'

import { Tag } from 'common/components'
import { parseZoneFormat } from 'common/dateFormatters'
import { formatMoney } from 'common/moneyFormatter'

const getExpenseStatus = (status: ExpenseStatus, product: any) => {
  switch (status) {
    case ExpenseStatus.ActionRequired:
      return <Tag color="blue">Action Required</Tag>
    case ExpenseStatus.AwaitingReview:
      return <Tag color="blue">Awaiting Review</Tag>
    case ExpenseStatus.PerksAwaitingReview:
      return <Tag color="blue">Awaiting Review</Tag>
    case ExpenseStatus.Verified:
      return <Tag color="green">Verified</Tag>
    case ExpenseStatus.Ineligible:
      if (product.productId === ProductIds.Perks) {
        return <Tag color="red">Rejected</Tag>
      } else {
        return <Tag color="red">Ineligible</Tag>
      }
  }
}

export const transactionTableColumns = (
  translate: (key: string) => string,
  filter: ReimbursementHistoryFilter,
  product: any,
): ColumnProps<ReimbursementHistoryItem>[] => {
  const columns: ColumnProps<ReimbursementHistoryItem>[] = [
    {
      title: translate('admin-dashboard.reimbursements.transactions.table.expenseId'),
      dataIndex: 'expenseNumber',
      key: 'expenseNumber',
      align: 'left',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      className: 't-expenseNumber',
    },
    {
      title: translate('admin-dashboard.reimbursements.transactions.table.firstName'),
      dataIndex: 'firstName',
      key: 'firstName',
      align: 'left',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      className: 't-firstName',
    },
    {
      title: translate('admin-dashboard.reimbursements.transactions.table.lastName'),
      dataIndex: 'lastName',
      key: 'lastName',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      className: 't-lastname',
    },
    {
      title: 'Family member',
      dataIndex: 'familyMember',
      key: 'familyMember',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      className: 't-familyMember',
    },
    {
      title: 'Reimbursed Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      sorter: true,
      className: 't-amount',
      render: (item: number) => {
        return formatMoney(item)
      },
    },
    {
      title: translate('admin-dashboard.reimbursements.transactions.table.submissionDate'),
      dataIndex: 'submissionDate',
      key: 'submissionDate',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (item: any) => {
        return parseZoneFormat(item)
      },
      className: 't-submissionDate',
    },
    {
      title: translate('admin-dashboard.reimbursements.transactions.table.purchaseDate'),
      dataIndex: 'approvedPurchasedDate',
      key: 'approvedPurchasedDate',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (approvedPurchasedDate?: string) =>
        approvedPurchasedDate ? parseZoneFormat(approvedPurchasedDate) : '-',
      className: 't-approvedDate',
    },
    {
      title: translate('admin-dashboard.reimbursements.transactions.table.scheduledDate'),
      dataIndex: 'scheduledDate',
      key: 'scheduledDate',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (item: string) => parseZoneFormat(item),
      className: 't-scheduledDate',
    },
  ]

  const columnToSort: any = columns.find((c) => c.key === filter.orderColumn)
  columnToSort.defaultSortOrder = filter.orderDescending ? 'descend' : 'ascend'

  return columns
}
